import { lazy } from 'react';
import { BarsOutlined } from '@ant-design/icons';
import { AppRouter } from '@tools/ui/types';

const prefixPath = '/communication-platform';

const CommunicationsDashboard = lazy(
  () =>
    import(
      /* webpackChunkName: "CommunicationPlatformRoutes" */ '../pages/dashboard'
    )
);

export const communicationPlatformRoutes: AppRouter = {
  modules: [
    {
      redirectFrom: [prefixPath, `${prefixPath}/*`]
    },
    {
      name: 'Dashboard',
      path: `${prefixPath}/dashboard`,
      pages: [],
      component: CommunicationsDashboard,
      icon: BarsOutlined
    }
  ]
};
